module.exports = __webpack_public_path__ + "img/j@2x.13e0bcb9.png";